function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import * as React from 'react';

var InlineSvg = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InlineSvg, _React$Component);

  function InlineSvg() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InlineSvg.prototype;

  _proto.render = function render() {
    var _React$createElement, _React$createElement2, _React$createElement3;

    var _this$props = this.props,
        name = _this$props.name,
        colour = _this$props.colour;
    var colourHex;

    if (colour && colour.charAt(0) === '#') {
      colourHex = colour;
    } else {
      switch (colour) {
        case 'cyan':
          colourHex = '#00aec7';
          break;

        case 'deepCyan':
          colourHex = '#0f849e';
          break;

        case 'teal':
          colourHex = '#00b398';
          break;

        case 'blue':
          colourHex = '#004b87';
          break;

        case 'white':
          colourHex = '#ffffff';
          0;
          break;

        case 'lightCyan':
          colourHex = '#7FD1E3';
          break;

        case 'grey': //deprecated. Use paleSky

        case 'paleSky':
          colourHex = '#646F80';
          break;

        case 'heather':
          colourHex = '#BBC4D1';
          break;

        case 'mischka':
          colourHex = '#bbc4d1';
          break;

        case 'dark-grey':
          colourHex = '#27251f';
          break;

        default:
          colourHex = '#00aec7';
        // cyan
      }
    }

    switch (name) {
      case 'linkedin':
        return /*#__PURE__*/React.createElement("svg", {
          name: name,
          height: "100%",
          fillRule: "evenodd",
          clipRule: "evenodd",
          strokeLinejoin: "round",
          strokeMiterlimit: 2,
          fill: colourHex,
          version: "1.1",
          viewBox: "0 0 512 512",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          className: this.props.className
        }, /*#__PURE__*/React.createElement("path", {
          d: "M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-288.985,423.278l0,-225.717l-75.04,0l0,225.717l75.04,0Zm270.539,0l0,-129.439c0,-69.333 -37.018,-101.586 -86.381,-101.586c-39.804,0 -57.634,21.891 -67.617,37.266l0,-31.958l-75.021,0c0.995,21.181 0,225.717 0,225.717l75.02,0l0,-126.056c0,-6.748 0.486,-13.492 2.474,-18.315c5.414,-13.475 17.767,-27.434 38.494,-27.434c27.135,0 38.007,20.707 38.007,51.037l0,120.768l75.024,0Zm-307.552,-334.556c-25.674,0 -42.448,16.879 -42.448,39.002c0,21.658 16.264,39.002 41.455,39.002l0.484,0c26.165,0 42.452,-17.344 42.452,-39.002c-0.485,-22.092 -16.241,-38.954 -41.943,-39.002Z"
        }));

      case 'twitter':
        return /*#__PURE__*/React.createElement("svg", (_React$createElement = {
          height: "512px",
          id: "Layer_1",
          style: {
            enableBackground: 'new 0 0 512 512'
          },
          fill: "#27251f",
          version: "1.1",
          viewBox: "0 0 512 512",
          width: "512px"
        }, _React$createElement["fill"] = colourHex, _React$createElement.className = this.props.className, _React$createElement), /*#__PURE__*/React.createElement("path", {
          d: "M492,109.5c-17.4,7.7-36,12.9-55.6,15.3c20-12,35.4-31,42.6-53.6c-18.7,11.1-39.4,19.2-61.5,23.5  C399.8,75.8,374.6,64,346.8,64c-53.5,0-96.8,43.4-96.8,96.9c0,7.6,0.8,15,2.5,22.1C172,179,100.6,140.4,52.9,81.7  c-8.3,14.3-13.1,31-13.1,48.7c0,33.6,17.1,63.3,43.1,80.7C67,210.7,52,206.3,39,199c0,0.4,0,0.8,0,1.2c0,47,33.4,86.1,77.7,95  c-8.1,2.2-16.7,3.4-25.5,3.4c-6.2,0-12.3-0.6-18.2-1.8c12.3,38.5,48.1,66.5,90.5,67.3c-33.1,26-74.9,41.5-120.3,41.5  c-7.8,0-15.5-0.5-23.1-1.4C62.9,432,113.8,448,168.4,448C346.6,448,444,300.3,444,172.2c0-4.2-0.1-8.4-0.3-12.5  C462.6,146,479,128.9,492,109.5z"
        }));

      case 'instagram':
        return /*#__PURE__*/React.createElement("svg", (_React$createElement2 = {
          xmlns: "http://www.w3.org/2000/svg",
          height: "512px",
          id: "Layer_1",
          style: {
            enableBackground: 'new 0 0 512 512'
          },
          fill: "#27251f",
          version: "1.1",
          viewBox: "0 0 24 24",
          width: "512px"
        }, _React$createElement2["fill"] = colourHex, _React$createElement2.className = this.props.className, _React$createElement2), /*#__PURE__*/React.createElement("path", {
          d: "M15.233 5.488c-.843-.038-1.097-.046-3.233-.046s-2.389.008-3.232.046c-2.17.099-3.181 1.127-3.279 3.279-.039.844-.048 1.097-.048 3.233s.009 2.389.047 3.233c.099 2.148 1.106 3.18 3.279 3.279.843.038 1.097.047 3.233.047 2.137 0 2.39-.008 3.233-.046 2.17-.099 3.18-1.129 3.279-3.279.038-.844.046-1.097.046-3.233s-.008-2.389-.046-3.232c-.099-2.153-1.111-3.182-3.279-3.281zm-3.233 10.62c-2.269 0-4.108-1.839-4.108-4.108 0-2.269 1.84-4.108 4.108-4.108s4.108 1.839 4.108 4.108c0 2.269-1.839 4.108-4.108 4.108zm4.271-7.418c-.53 0-.96-.43-.96-.96s.43-.96.96-.96.96.43.96.96-.43.96-.96.96zm-1.604 3.31c0 1.473-1.194 2.667-2.667 2.667s-2.667-1.194-2.667-2.667c0-1.473 1.194-2.667 2.667-2.667s2.667 1.194 2.667 2.667zm4.333-12h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm.952 15.298c-.132 2.909-1.751 4.521-4.653 4.654-.854.039-1.126.048-3.299.048s-2.444-.009-3.298-.048c-2.908-.133-4.52-1.748-4.654-4.654-.039-.853-.048-1.125-.048-3.298 0-2.172.009-2.445.048-3.298.134-2.908 1.748-4.521 4.654-4.653.854-.04 1.125-.049 3.298-.049s2.445.009 3.299.048c2.908.133 4.523 1.751 4.653 4.653.039.854.048 1.127.048 3.299 0 2.173-.009 2.445-.048 3.298z"
        }));

      case 'facebook':
        return /*#__PURE__*/React.createElement("svg", (_React$createElement3 = {
          height: "100%",
          name: name
        }, _React$createElement3["height"] = "100%", _React$createElement3.fillRule = "evenodd", _React$createElement3.clipRule = "evenodd", _React$createElement3.strokeLinejoin = "round", _React$createElement3.strokeMiterlimit = 2, _React$createElement3.fill = colourHex, _React$createElement3.version = "1.1", _React$createElement3.viewBox = "0 0 512 512", _React$createElement3.width = "100%", _React$createElement3.xmlns = "http://www.w3.org/2000/svg", _React$createElement3.className = this.props.className, _React$createElement3), /*#__PURE__*/React.createElement("path", {
          d: "M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-106.468,0l0,-192.915l66.6,0l12.672,-82.621l-79.272,0l0,-53.617c0,-22.603 11.073,-44.636 46.58,-44.636l36.042,0l0,-70.34c0,0 -32.71,-5.582 -63.982,-5.582c-65.288,0 -107.96,39.569 -107.96,111.204l0,62.971l-72.573,0l0,82.621l72.573,0l0,192.915l-191.104,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Z"
        }));

      case 'youtube':
        return /*#__PURE__*/React.createElement("svg", {
          className: this.props.className,
          fill: colourHex,
          height: "1792",
          viewBox: "0 0 1792 1792",
          width: "1792",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M1099 1244v211q0 67-39 67-23 0-45-22v-301q22-22 45-22 39 0 39 67zm338 1v46h-90v-46q0-68 45-68t45 68zm-966-218h107v-94h-312v94h105v569h100v-569zm288 569h89v-494h-89v378q-30 42-57 42-18 0-21-21-1-3-1-35v-364h-89v391q0 49 8 73 12 37 58 37 48 0 102-61v54zm429-148v-197q0-73-9-99-17-56-71-56-50 0-93 54v-217h-89v663h89v-48q45 55 93 55 54 0 71-55 9-27 9-100zm338-10v-13h-91q0 51-2 61-7 36-40 36-46 0-46-69v-87h179v-103q0-79-27-116-39-51-106-51-68 0-107 51-28 37-28 116v173q0 79 29 116 39 51 108 51 72 0 108-53 18-27 21-54 2-9 2-58zm-608-913v-210q0-69-43-69t-43 69v210q0 70 43 70t43-70zm719 751q0 234-26 350-14 59-58 99t-102 46q-184 21-555 21t-555-21q-58-6-102.5-46t-57.5-99q-26-112-26-350 0-234 26-350 14-59 58-99t103-47q183-20 554-20t555 20q58 7 102.5 47t57.5 99q26 112 26 350zm-998-1276h102l-121 399v271h-100v-271q-14-74-61-212-37-103-65-187h106l71 263zm370 333v175q0 81-28 118-37 51-106 51-67 0-105-51-28-38-28-118v-175q0-80 28-117 38-51 105-51 69 0 106 51 28 37 28 117zm335-162v499h-91v-55q-53 62-103 62-46 0-59-37-8-24-8-75v-394h91v367q0 33 1 35 3 22 21 22 27 0 57-43v-381h91z"
        }));

      default:
        return /*#__PURE__*/React.createElement("strong", null, "Error: no case in InlineSVG for ", name);
    }
  };

  return InlineSvg;
}(React.Component);

export default InlineSvg;